import OrderStatus from './OrderStatus';
import OrderService from './OrderService';

export const orderStatus = new OrderStatus();

export const orderService = new OrderService(orderStatus);